import React from 'react'
import './VideoEmbed.scss'

const VideoEmbed = props => {
  return (
    <div className="video-embed-container">
      <embed width={'850'} height={'479'} src={props.embed} />
    </div>
  )
}

export default VideoEmbed
